// @flow
import * as React from 'react'
import createField from './createField'

// Types
import type { Props } from './Field'

/**
 * Helper function that makes it easier to wrap any field with `createField`
 * @type {[type]}
 */
const wrapWithField = <T: React.ComponentType<any>>(
  Component: T,
  options?: $Shape<Props>
): T =>
  (createField(
    (props, nest, deepOptions, controller) => (
      <Component
        nest={nest}
        controller={controller}
        {...props}
        {...deepOptions}
      />
    ),
    options
  ): any)

export default wrapWithField
